/**
 * @fileoverview Workspace Task Labels
 *
 * URL: /dashboard/task-labels
 *
 * Firm-defined tags applied to tasks for filtering and grouping. Lives under
 * the workspace Calendar section in the sidebar (more logical than buried in
 * Settings). Admin/owner can create, edit, recolour and reorder; system
 * labels are protected from deletion.
 *
 * - Convex: tasks.labels.*
 */
import { createFileRoute } from "@tanstack/react-router";
import type { Id } from "@cvx/_generated/dataModel";
import { useActiveOrg } from "@/utils/org-context";
import { TaskLabelsManager } from "@/components/settings/tasks/TaskLabelsManager";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/task-labels",
)({
  component: TaskLabelsPage,
});

function TaskLabelsPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const canEdit = activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      {orgId ? (
        <TaskLabelsManager
          orgId={orgId as Id<"organizations">}
          canEdit={canEdit}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to manage task labels.
        </div>
      )}
    </div>
  );
}
